<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'article/index' }">
                                Berita
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ article.title }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Berita {{ [article.createdAt, "YYYY-MM-DD HH:mm:ss"] | moment("dddd, D MMMM YYYY") }}
                                </span>
                            </div>
                            <div class="col-auto">
                                <router-link v-bind:to="{name: 'article/edit', params: {id: article.id}}" class="btn btn-link h4 p-0 my-0 mr-2">
                                    Edit
                                </router-link>
                                <button class="btn btn-link h4 p-0 my-0" v-on:click="modal = true">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="text-muted">
                            Banner Berita:
                        </div>
                        <img v-bind:src="article.imageUrl" class="img-fluid mb-2 rounded w-100" />
                        <div class="text-muted">
                            Judul Banner:
                        </div>
                        <p class="card-text font-weight-bold">
                            {{ article.title }}
                        </p>
                        <div class="text-muted">
                            Kalimat Pembuka:
                        </div>
                        <p class="card-text">
                            {{ article.foreword }}
                        </p>
                        <div class="text-muted">
                            Isi Berita:
                        </div>
                        <div v-html="article.content"></div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal v-model="modal" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus berita ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    export default {
        name: "ArticleView",
        data() {
            return {
                article: {},
                modal: false
            };
        },
        methods: {
            remove() {
                this.axios.post(process.env.API_URL + '/article/delete/' + this.article.id).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'article/index'});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                    this.modal = false;
                });
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/article/' + this.$route.params.id).then(response => {
                this.article = response.data.data.current;

                document.title = this.article.title + ' - ' + process.env.APP_NAME;
            });
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/article/View.vue